import { createRouter, createWebHashHistory } from 'vue-router'

import { AdsRouter } from '@/pages/ads/ads.router'
import { DashboardAnalyticsRouter } from '@/pages/analytics/dashboardAnalytics.router'
import { GuestTypeRouter } from '@/pages/guestTypes/guestType.router'
import { ImportRouter } from '@/pages/import/import.router'
import { SwaggerRouter } from '@/pages/swagger/swagger.router'
import { VideoRouter } from '@/pages/video/video.router'
import { YurplanTicketsRouter } from '@/pages/yurplanTickets/yurplanTickets.router'

import { ApplicationCfgRouter } from './pages/applicationCfg/applicationCfg.router'
import { AttendeesWhiteListRouter } from './pages/attendee-white-list/attendeesWhiteList.router'
import { AttendeeRouter } from './pages/attendee/attendee.router'
import { ConfigDevRouter } from './pages/configDev/configDev.router'
import { DashboardRouter } from './pages/dashboard/dashboard.router'
import { FestivalRouter } from './pages/festival/festival.router'
import { useFestivalStore } from './pages/festival/festival.store'
import { GalleryRouter } from './pages/gallery/gallery.router'
import { GenresRouter } from './pages/guests/genres.router'
import { GuestsRouter } from './pages/guests/guest.router'
import { InfosRouter } from './pages/infos/infos.router'
import { LoginRouter } from './pages/login/login.router'
import { MapRouter } from './pages/map/map.router'
import { MenuRouter } from './pages/menuEntries/menu.router'
import { NewsArticleRouter } from './pages/newsArticles/newsArticle.router'
import { NotificationsRouter } from './pages/notifications/notifications.router'
import { NotificationsTopicsRouter } from './pages/notificationsTopics/notificationsTopics.router'
import { OrphanedRouter } from './pages/orphaned/orphaned.router'
import { privateSectionsRouter } from './pages/privateSections/privateSections.router'
import { ProgEventRouter } from './pages/progEvent/progEvent.router'
import { ProgramsRouter } from './pages/programs/programs.router'
import { PublicationRouter } from './pages/publications/publication.router'
import { ResetAppRouter } from './pages/resetApp/resetApp.router'
import { ScenesRouter } from './pages/scenes/scenes.router'
import { splashScreenRouter } from './pages/splashScreen/splashScreen.router'
import { SponsorsRouter } from './pages/sponsors/sponsors.router'
import { StaticCfgRouter } from './pages/staticCfg/staticCfg.router'
import { StoresInformationsRouter } from './pages/storesInformations/storesInformations.router'
import { useStoresInformationsStore } from './pages/storesInformations/storesInformations.store'
import { UsersRouter } from './pages/users/users.router'
import { ValidationMailSentRouter } from './pages/validationMailSent/validationMailSent.router'
import { useAppConfigStore } from './shared/store/app-config.store'
import { useSessionStore } from './shared/store/session.store'

export const publicRoutes = ['/ValidationMailSent']

const routes = [
  ...LoginRouter,
  ...ResetAppRouter,
  ...OrphanedRouter,
  ...ConfigDevRouter,
  ...ApplicationCfgRouter,
  ...AdsRouter,
  ...StaticCfgRouter,
  ...PublicationRouter,
  ...UsersRouter,
  ...NotificationsRouter,
  ...NotificationsTopicsRouter,
  ...MenuRouter,
  ...AttendeesWhiteListRouter,
  ...StoresInformationsRouter,
  ...FestivalRouter,
  ...InfosRouter,
  ...SponsorsRouter,
  ...AttendeeRouter,
  ...GuestsRouter,
  ...GenresRouter,
  ...ScenesRouter,
  ...ProgramsRouter,
  ...ProgEventRouter,
  ...DashboardRouter,
  ...MapRouter,
  ...GalleryRouter,
  ...ValidationMailSentRouter,
  ...SwaggerRouter,
  ...splashScreenRouter,
  ...DashboardAnalyticsRouter,
  ...GuestTypeRouter,
  ...ImportRouter,
  ...NewsArticleRouter,
  ...privateSectionsRouter,
  ...VideoRouter,
  ...YurplanTicketsRouter,
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach(async (to) => {
  if (publicRoutes.includes(to.path)) {
    return
  }

  if (
    useSessionStore.getState().key == null &&
    useSessionStore.getState().redirectAfterLogin == null
  ) {
    await useSessionStore.getState().loadSession()
  }

  if (useSessionStore.getState().key == null && to.path !== '/login') {
    useSessionStore.getState().setRedirectAfterLogin(to.path)
    return '/login'
  }

  // If already authenticated and navigating to /login (e.g. after fe-version reload),
  // redirect to home instead of showing the login page
  if (useSessionStore.getState().key != null && to.path === '/login') {
    return '/'
  }

  if (to.path !== '/login') {
    await Promise.all([
      useStoresInformationsStore.getState().appStore == null
        ? useStoresInformationsStore.getState().loadAppStore()
        : undefined,
      useAppConfigStore.getState().appConfig == null
        ? useAppConfigStore.getState().loadAppConfig()
        : undefined,
      useFestivalStore.getState().festival == null
        ? useFestivalStore.getState().loadFestival()
        : undefined,
    ])

    // If session was lost during data loading (e.g. 401 on concurrent requests),
    // redirect to login instead of showing a broken page
    if (useSessionStore.getState().key == null) {
      useSessionStore.getState().setRedirectAfterLogin(to.path)
      return '/login'
    }
  }
})

export default router
